import React, { useState } from "react";
import styled from "styled-components";

import { Wrapper, NavText, NavTitle } from "./nav_components.js";
import { StyledBox } from "../../cards/card_componets.js";
import { BnameBadges } from "../solution/solution_components.js";
import { GraphTitle, VehicleGraph } from "./graph.js";
import { Component } from "react";

export const dictSigungu = {};
dictSigungu['강남구']=['서초구','송파구','성동구','광진구'];
dictSigungu['강동구']=['중랑구','광진구','송파구','동대문구'];
dictSigungu['강서구']=['마포구','양천구','구로구','영등포구'];
dictSigungu['강북구']=['도봉구','노원구','성북구','종로구'];
dictSigungu['관악구']=['금천구', '영등포구', '동작구', '서초구'];
dictSigungu['광진구']=['중랑구', '성동구', '송파구', '강동구'];
dictSigungu['구로구']=['양천구','영등포구','금천구','관악구'];
dictSigungu['금천구']=['구로구','영등포구','동작구','관악구'];
dictSigungu['노원구']=['도봉구','강북구','성북구','중랑구'];
dictSigungu['동대문구']=['성북구','중랑구','성동구','중구'];
dictSigungu['도봉구']=['강북구', '노원구', '성북구', '중랑구'];
dictSigungu['동작구']=['영등포구', '관악구', '서초구', '용산구'];
dictSigungu['마포구']=['서대문구', '용산구', '영등포구', '강서구'];
dictSigungu['서대문구']=['은평구', '종로구', '중구', '마포구'];
dictSigungu['성동구']=['동대문구', '광진구', '중구', '강남구'];
dictSigungu['성북구']=['강북구', '종로구', '동대문구', '노원구'];
dictSigungu['서초구']=['용산구', '강남구', '동작구', '관악구'];
dictSigungu['송파구']=['광진구', '강동구', '강남구', '성동구'];
dictSigungu['영등포구']=['마포구', '양천구', '동작구', '용산구'];
dictSigungu['용산구']=['중구', '마포구', '동작구', '서초구'];
dictSigungu['양천구']=['강서구', '영등포구', '구로구', '마포구'];
dictSigungu['은평구']=['마포구', '서대문구', '종로구', '성북구'];
dictSigungu['종로구']=['은평구', '서대문구', '중구', '성북구'];
dictSigungu['중구']=['종로구', '성동구', '용산구', '서대문구'];
dictSigungu['중랑구']=['노원구', '성북구', '동대문구', '광진구'];


export default class VehicleNum extends Component{

render() {
  var sigungu = sessionStorage.getItem("sigungu");

  return (
    <Wrapper>
      <NavTitle> 내 주차장 주변 지역 차량등록 현황</NavTitle>
      <NavText> 내 주차장 주변 지역에 얼마나 많은 차량이 등록되어있는지 알려드립니다.</NavText>
      <StyledBox height="620" width="1200" padding="40">
        <GraphTitle fontSize="20" marginTop="20" marginBottom="50">
          <BnameBadges bname={dictSigungu[sigungu][0]}></BnameBadges>
          <BnameBadges bname={dictSigungu[sigungu][1]}></BnameBadges>
          <BnameBadges bname={dictSigungu[sigungu][2]}></BnameBadges>
          <BnameBadges bname={dictSigungu[sigungu][3]}></BnameBadges>
          의 차량등록 현황
        </GraphTitle>
        <VehicleGraph />
      </StyledBox>
    </Wrapper>
  );
}
}
